import qs from 'qs';
import { axiosAPI } from '@/axios';

const loadLandingPage = (filter) => {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  if (query) {
    return axiosAPI.get(`/landing-pages${query}`);
  }
  return axiosAPI.get('/landing-pages');
};

const loadLandingPagebyId = (id) => {
  return axiosAPI.get(`/landing-pages/${id}`);
};

const createLandingPage = (payload) => {
  return axiosAPI.post('/landing-pages', payload);
};

const updateLandingPage = (id, payload) => {
  return axiosAPI.put(`/landing-pages/${id}`, payload);
};

const deleteLandingPage = (id) => {
  return axiosAPI.delete(`/landing-pages/${id}`);
};

export {
  loadLandingPage,
  loadLandingPagebyId,
  createLandingPage,
  updateLandingPage,
  deleteLandingPage,
};
